module.exports = __webpack_public_path__ + "static/media/icons8-carrot-480.9c602676.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-carrot/light/icons8-carrot-480.png
// module id = 1924
// module chunks = 2